<template>

    <header id="myheader" >
      <!-- <div  :class="{pin:scroll > 100, header:scroll >-1 }"> -->
        <div  class="header">

        <div class="">
            <div class="vrh" >
          <div class="wrapper">

                <span>e-mail - office@virginia.rs</span>
                <p>Mob: 00 381 (0)65 500 52 25</p>
            </div>
          </div>
          <br>
          <nav class="nav">
            <div class="logo animated fadeIn slower">
            <router-link  to="/"> <img @click="scrollToTop()" src="static/imgs/logotip.jpg" alt=""> </router-link>
            </div>
            <div class="logom">
              <!-- <h2 style="font-size: 20px;float: left;margin-top: 10px;" @click="mob=!mob"><i class="fa fa-bars"></i></h2> -->
              <router-link  to="/"> <img @click="scrollToTop()" src="static/imgs/logotip.jpg" alt=""> </router-link>
            </div>
            <div  :class="{containeri:!mob, change:mob }" @click="myFunction()">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
            </div>
            <div class="search">
              <p v-if="cart.length > 0 ">{{cart.length}}</p>
              <router-link  to="/korpa"><img @click="scrollToTop()" src="static/imgs/basket.png" alt=""></router-link>
            </div>




            <div id="navi" class="nav">
              <ul>
                <li :class="{active:selected == '/'}" ><router-link  to="/"><i class="fa fa-home"></i> Naslovna</router-link></li>
                <li  :class="{active:selected == '/o-nama'}" ><router-link to="/o-nama">O nama</router-link></li>
                <li  :class="{active:selected == '/proizvodi'}" ><router-link  to="/proizvodi">Proizvodi</router-link></li>
                <li  :class="{active:selected == '/test'}" ><router-link  to="/test">Testiranja</router-link></li>
                <li  :class="{active:selected == '/saveti'}" ><router-link  to="/saveti">Saveti</router-link></li>
                <li  :class="{active:selected == '/kontakt'}" ><router-link  to="/kontakt">Kontakt</router-link></li>

              </ul>

            </div>



           <div class="icon">

             <div class="logo animated fadeIn slower">
             <router-link  to="/"> <img @click="scrollToTop()" src="static/imgs/logotip.jpg" alt=""> </router-link>
             </div>

           </div>


          </nav>


        </nav>

        <!-- <login-user class=""  v-show="showLogin"></login-user> -->

        </div>
        <div v-if="mob" id="navmob" class="animated bounceInLeft slower">
          <ul>
            <li></li>
            <li @click="scrollToTop()" ><router-link  to="/"><i class="fa fa-home"></i> Naslovna</router-link></li>
            <li  @click="scrollToTop()" ><router-link to="/o-nama">O nama</router-link></li>
            <li  @click="scrollToTop()" ><router-link  to="/proizvodi">Proizvodi</router-link></li>
            <li  @click="scrollToTop()" ><router-link  to="/test">Testiranja</router-link></li>
            <li  @click="scrollToTop()" ><router-link  to="/saveti">Saveti</router-link></li>
            <li  @click="scrollToTop()" ><router-link  to="/kontakt">Kontakt</router-link></li>
            <li style="text-align:right; margin-right:10px" @click="mob=false" >X</li>
         </ul>

        </div>
     </div>
     <div class="scroll" v-if="scroll>800">
      <i  @click="move()"class="fas fa-chevron-circle-up" title="Idi na vrh strane"></i>
    </div>
  </header>

</template>

<script>
// import loginUser from '@/components/loginUser'

import {mapGetters, mapActions, mapMutations} from 'vuex'
// import {bus} from '@/main.js'
// import Slider from '@jeremyhamm/vue-slider'

export default {
  components: {
  // loginUser,

  // 'slider': Slider,
  },
  name: 'myheader',
  data () {
    return {
      scroll:0,
      mob:false,
      searching:"",
      result:[],
      searches:false,
      scroll:0,
      selected:"",
      showLogin: false,
      showsearch: false
    }
    },
    computed:{
              ...mapGetters([
                'cart',
              ]),


    },

    methods:{
      myFunction(x) {
        this.mob=!this.mob
      },
      move(){
   window.scrollTo({top: 0, behavior: 'smooth'});
  },
      goto(proid,proname){
        this.searches= !this.searches;
        this.$router.push("/products/"+proid+"/"+proname)

      },
      proba(e){
        this.setsearch(!this.getsearch)
          e.stopPropagation()
      },
      scrollToTop() {
              this.mob = false
              window.scrollTo(0,0);
         },
      ...mapActions([
        // 'logout',
        // 'login'
      ]),
      ...mapMutations([

    ]),

closeLogin(){
      this.showLogin = false;
      },
Login(e) {
        this.showLogin = !this.showLogin
        this.showregister = false;
        e.stopPropagation()
      },

Sign(e) {
        this.showLogin = false;
        this.showregister = !this.showregister
        e.stopPropagation()
      },

    },

  watch:{
        getsearch:function(){
          if(this.getsearch){
            this.showLogin = !this.showLogin
          }
        },
        searching:function(){

          if (this.searching.length < 1) {
            return this.result=[]
          }
         this.searches = true
          this.result = this.proizvodi.filter(pro => {
               return pro.pro_name.toUpperCase().match(this.searching.toUpperCase());
          })
        },
        $route:function(){
          var ruta = this.$route.path
          var proba = ruta.split('/')
          this.selected='/'+proba[1];
      },


      },

mounted(){
  window.onscroll = () => {
      this.scroll = window.pageYOffset;
 }
var ruta = this.$route.path
var proba = ruta.split('/')
this.selected='/'+proba[1];

//   document.addEventListener('click', () => {
//   this.setsearch(false);
//
// })

// this.getproducts();

    },

}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.animated{
  animation-duration: 0.5s;
}
.scroll{
  color: var(--crvena);
  opacity: 0.8;
  position: fixed;
  bottom: 50px;
  font-size: 30px;
  width: 30px;
  right: 20px;
  z-index: 10;
}
.scroll i:hover{
  cursor: pointer;
  color: var(--zelena)
}
</style>



// WEBPACK FOOTER //
// src/components/myheader.vue